import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { propType } from 'graphql-anywhere';
import Multiselect from 'react-widgets/lib/Multiselect';

import { querySelector } from '../../utils';

export class UserPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(items, meta) {
    const { action, dataItem } = meta;

    /*
    * Multiselect will call onChange even when no items are to be removed. Therefore, we need an
    * explicit case catching this.
    */
    if (!dataItem) {
      return;
    }

    switch (action) {
      case 'insert':
        this.props.onAdd(dataItem);
        break;
      case 'remove':
        this.props.onRemove(dataItem);
        break;
      default:
        throw new Error(`invalid change action: ${action}`);
    }
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  render() {
    const {
      value, userScope,
    } = this.props;
    const { open } = this.state;
    return (
      <Multiselect
        value={value}
        onChange={this.handleChange}
        data={userScope}
        open={open}
        onFocus={this.handleOnFocus}
        onToggle={this.handleOnToggle}
        onMouseDown={(e) => { e.preventDefault(); }}
        filter="contains"
        textField={(user) => { return `${user.firstname} ${user.lastname}`; }}
      />
    );
  }
}

UserPicker.fragments = {
  user: gql`
    fragment UserPickerUser on User {
      id
      firstname
      lastname
    }
  `,
};

UserPicker.propTypes = exact({
  value: PropTypes.arrayOf(propType(UserPicker.fragments.user)).isRequired,
  userScope: PropTypes.arrayOf(propType(UserPicker.fragments.user)).isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  /* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */
  data: PropTypes.object,
});

UserPicker.defaultProps = {
  onAdd: () => {},
  onRemove: () => {},
  data: {},
};

const AllUsers = gql`
  query AllUsers {
    all_users(exclude_salary: true, exclude_terminated: true, exclude_terminated_before: 2) {
      edges {
        node {
          ...UserPickerUser
        }
      }
    }
  }
  ${UserPicker.fragments.user}
`;

const marshallData = ({ data, ownProps }) => {
  const userScope = querySelector(data, '$.all_users.edges[*].node', []);
  return {
    ...ownProps,
    userScope,
  };
};

const withData = graphql(AllUsers, { props: marshallData });

export default withData(UserPicker);
